import { Navigate } from "react-router-dom";
import { useCandidateAuth } from "@/contexts/CandidateAuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedCandidateRoute({ children }) {
  const { isAuthenticated, loading } = useCandidateAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/candidate/login" replace />;
  }

  return children;
}
